import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { imgUrl } from "@/lib/api";

export const ProductCard = ({ p, index = 0 }) => {
  const from = Math.min(...p.variants.map((v) => v.price));
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: (index % 3) * 0.08 }}
    >
      <Link to={`/product/${p.slug}`} data-testid={`product-card-${p.slug}`} className="group block">
        <div className="relative aspect-[4/5] bg-[#121212] overflow-hidden border border-[#1c1c1c]">
          <img src={imgUrl(p.image_url)} alt={p.name} className="hover-img w-full h-full object-cover" />
          <span className="absolute top-3 left-3 overline bg-[#080808]/70 backdrop-blur px-2 py-1">{p.category}</span>
        </div>
        <div className="flex items-start justify-between mt-4">
          <div>
            <h3 className="font-display text-2xl leading-none group-hover:text-[#C7F000] transition-colors">{p.name}</h3>
            <p className="text-[11px] italic text-[#8A8782] font-display mt-1">{p.scientific_name}</p>
          </div>
          <span className="text-xs text-[#8A8782] whitespace-nowrap mt-1">from ${from.toFixed(2)}</span>
        </div>
      </Link>
    </motion.div>
  );
};
